import { render, staticRenderFns } from "./agent-setup.vue?vue&type=template&id=68018550&scoped=true&"
import script from "./agent-setup.vue?vue&type=script&lang=ts&"
export * from "./agent-setup.vue?vue&type=script&lang=ts&"
import style0 from "./agent-setup.vue?vue&type=style&index=0&id=68018550&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68018550",
  null
  
)

export default component.exports